import { useLocation } from "react-router-dom";
import ConfigData from "./../Config/config.json";
const useConfig = (): {
  logoUrl: string;
  headerLogo: string;
  giftPageLogo: string;
  paymentPageLogo: string;
  subscribePromoImage?: string;
  planpage: boolean;
  customer: string;
  name: string;
  title: string;
  subtitle: string;
  primary: string;
  secondary: string;
  returnUrl: string;
  tertiary: string;
  privacyText: string;
  stripePublishableKey: string;
  supportEmail: string;
  gTag: string;
  api_url: string;
  supportUrl: string;
  buttonCommonClass: string;
  manageButtonClass: string;
  favicon: string;
  personalChannel: string;
  mainName: string;
  jwPlayerID: string;
  privacyLink: string;
  s3HostUrl: string;
  planHeader: string;
  liniusUrl: string;
  bitMovinKey: string;
  analysticBitmovinKey: string;
  ad_url?: string;
  xApiKey: string;
  search_api_url?: string;
  /**
   * The one surviving per-tenant switch. NOT the old flag system: `lib/flags.ts`
   * and `useV2Flag` are gone, and so is every page gate they carried, because
   * those were "is this tenant on the redesign" and every tenant now is.
   *
   * This one answers a different question that is still tenant by tenant: does
   * an upstream serve a GameSheet box score for this tenant's games. Only the
   * leagues GameSheet actually covers do, which is why it is not simply on.
   */
  v2?: { gameDetails?: boolean };
} => {
  const location = useLocation();
  const data: {
    [key: string]: {
      logoUrl: string;
      headerLogo: string;
      giftPageLogo: string;
      paymentPageLogo: string;
      subscribePromoImage?: string;
      planpage: boolean;
      customer: string;
      name: string;
      primary: string;
      secondary: string;
      tertiary: string;
      favicon: string;
      personalChannel: string;
      mainName: string;
      returnUrl: string;
      manageButtonClass: string;
      buttonCommonClass: string;
      privacyLink: string;
      supportEmail: string;
      title: string;
      supportUrl: string;
      subtitle: string;
      stripePublishableKey: string;
      gTag: string;
      privacyText: string;
      jwPlayerID: string;
      s3HostUrl: string;
      api_url: string;
      planHeader: string;
      liniusUrl: string;
      bitMovinKey: string;
      analysticBitmovinKey: string;
      ad_url?: string;
      xApiKey: string;
      search_api_url?: string;
        };
  } = ConfigData;

  const websiteName: any = process.env.REACT_APP_ENV;

  return data?.[websiteName];
};
export default useConfig;
